const validate = values => {
  const errors = {};
  if (!values.tar_curso) {
    errors.tar_curso = 'Campo Obrigatório';
  }
  if (!values.tar_semestre) {
    errors.tar_semestre = 'Campo Obrigatório';
  }
  if (!values.tar_entrega) {
    errors.tar_entrega = 'Campo Obrigatório';
  }
  if (!values.tar_descricao) {
    errors.tar_descricao = 'Campo Obrigatório';
  }
  if (!values.tar_data_inicio) {
    errors.tar_data_inicio = 'Campo Obrigatório';
  }
  if (!values.tar_data_fim) {
    errors.tar_data_fim = 'Campo Obrigatório';
  }
  if (!values.tar_data_entrega) {
    errors.tar_data_entrega = 'Campo Obrigatório';
  }
  if (!values.turma) {
    errors.turma = 'Campo Obrigatório';
  }
  if (!values.flag_equipe) {
    errors.flag_equipe = 'Campo Obrigatório';
  }
  if (!values.descricao) {
    errors.descricao = 'Campo Obrigatório';
  }

  if (!values.tar_cod_dis_tur) {
    errors.tar_cod_dis_tur = 'Campo Obrigatório';
  }
  // else if (values.descricao.length == 400) {
  //   errors.descricao = 'Este campo deve ter 400 caracteres no máximo.'
  // }

  if (!values.titulo) {
    errors.titulo = 'Campo Obrigatório';
  }
  // else if (values.titulo.length > 80) {
  //   errors.titulo = 'Este campo deve ter 80 caracteres no máximo.'
  // }

  // if (!values.txt_recompensa) {
  //   errors.txt_recompensa = 'Campo Obrigatório';
  // }
  // else if (values.txt_recompensa.length == 40) {
  //   errors.txt_recompensa = 'Este campo deve ter 40 caracteres no máximo.'
  // }

  //  if (values.feedback.length == 40) {
  //    errors.feedback = 'Este campo deve ter 40 caracteres no máximo.'
  //  }
  
  if (!values.objetivo) {
    errors.objetivo = 'Campo Obrigatório';
  }

  if (!values.tar_midia) {
    errors.tar_midia = 'Campo Obrigatório';
  }
  
  // else if (values.objetivo.length == 200) {
  //   errors.objetivo = 'Este campo deve ter 200 caracteres no máximo.'
  // }
  // if (!values.tar_file) {
  //   errors.tar_file = 'Campo Obrigatório';
  // }

  return errors;
};

export default validate;




// WEBPACK FOOTER //
// ./src/service/validate_tarefas.js